import { combineReducers } from 'redux';

import loadingReducer from 'modules/global/reducers/generic.loading';
import { QUESTION_MODEL_STATISTICS_ANSWERS } from 'modules/questionModels/actionTypes';

import answers from './answers';
import count from './count';
import exportModal from './exportModal';
import filters from './filters';
import selectedId from './selectedId';

/**
 * @typedef {{
 *  selectedId: string,
 *  count: number,
 *  filters: import('modules/statistics/types').FilterRequest,
 *  exportModal: import('modules/statistics/types').ExportModal
 * }} QuestionModelStatisticDataReducer
 */

export default combineReducers({
  selectedId,
  answers,
  isLoadingAnswers: loadingReducer(QUESTION_MODEL_STATISTICS_ANSWERS),
  count,
  filters,
  exportModal,
});
